// import Vue from 'vue';

// HELPERS
// const monthNames = [
//     "January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"
// ];

// const dayNames = [
//     'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'
// ]

function correctTime(v) { return v.toLocaleString().length === 1 ? `0${v}` : v }
// ./HELPERS


export function toTime(val) {
    if (!val) return ''
    const d = val
    return `${correctTime(d.getHours())}:${correctTime(d.getMinutes())}`
}

// 1914-12-20T08:00
export function toHTMLDateTime(val) {
    if (!val) return ''
    const d = val
    return `${d.getFullYear()}-${d.getMonth() + 1}-${d.getDate()}T${correctTime(d.getHours())}:${correctTime(d.getMinutes())}`
}

export function toHTMLDate(val) {
    if (!val) return ''
    const d = val
    return `${d.getFullYear()}-${d.getMonth() + 1}-${d.getDate()}`
}

export function toCategoryDateTime(val) {
    if (!val) return ''
    const d = val
    return `${d.getDate()}-${d.getMonth()}-${d.getDay()}`
}


export function toDateFormat(val) {
    if (!val) return ''
    return `${val.getDate()}-${val.getMonth()}-${val.getFullYear()}`
}


export function truncate(text, length, suffix = '...') {
    if (text.length > length) {
        return text.substring(0, length) + suffix;
    } else {
        return text;
    }
}

export function capitalize(value) {
    if (!value) return ''
    value = value.toString()
    return value.charAt(0).toUpperCase() + value.slice(1)
}

export function toUpperCaseTurkish(val) {
    let string = val;
    const letters = { "i": "İ", "ş": "Ş", "ğ": "Ğ", "ü": "Ü", "ö": "Ö", "ç": "Ç", "ı": "I" };
    string = string.replace(/(([iışğüçö]))/g, function (letter) { return letters[letter]; })
    return string.toUpperCase();
}

export function toLowerCaseTurkish(val) {
    let string = val;
    const letters = { "İ": "i", "I": "ı", "Ş": "ş", "Ğ": "ğ", "Ü": "ü", "Ö": "ö", "Ç": "ç" };
    string = string.replace(/(([İIŞĞÜÇÖ]))/g, function (letter) { return letters[letter]; })
    return string.toLowerCase();
}

const filters = { truncate, toHTMLDateTime, toTime, toHTMLDate, toCategoryDateTime, 
                  capitalize, toUpperCaseTurkish, toLowerCaseTurkish, toDateFormat }

export default filters
